import { render, staticRenderFns } from "./Inspeccion.vue?vue&type=template&id=39da8996&scoped=true"
import script from "./Inspeccion.vue?vue&type=script&lang=js"
export * from "./Inspeccion.vue?vue&type=script&lang=js"
import style0 from "./Inspeccion.vue?vue&type=style&index=0&id=39da8996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da8996",
  null
  
)

export default component.exports